import { useMutation, useQueryClient, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";
import { CreateActionPlanRequest, ActionPlanSummary } from "@mutiny-group/sbo-openapi-client";
import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";

type CreateActionPlanOptions = {
  scenarioBuilderClient: ScenarioBuilderClient;
  createActionPlanRequest: CreateActionPlanRequest;
};

const createActionPlan = ({
  scenarioBuilderClient,
  createActionPlanRequest,
}: CreateActionPlanOptions) => {
  return scenarioBuilderClient.actionPlans.createActionPlan({
    createActionPlanRequest,
  });
};

type UseCreateActionPlanOptions = {
  config?: UseMutationOptions<ActionPlanSummary, AxiosError, CreateActionPlanRequest>;
};

export const useCreateActionPlan = ({ config }: UseCreateActionPlanOptions = {}) => {
  const queryClient = useQueryClient();
  const scenarioBuilderClient = useScenarioBuilderClient();

  return useMutation({
    mutationFn: (createActionPlanRequest: CreateActionPlanRequest) =>
      createActionPlan({ scenarioBuilderClient, createActionPlanRequest }),
    onSuccess: async () => {
      toast.success("Action Plan created successfully!");
      await queryClient.invalidateQueries({ queryKey: ["action-plans"] });
    },
    onError: (error) => {
      toast.error("Failed to create action plan. Please try again.");
      console.error("useCreateActionPlan onError", error);
    },
    ...config,
  });
};
